import { render, staticRenderFns } from "./PurchasePerMonthCompareSettings.vue?vue&type=template&id=6e7307ee&scoped=true"
import script from "./PurchasePerMonthCompareSettings.vue?vue&type=script&lang=ts"
export * from "./PurchasePerMonthCompareSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7307ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7307ee')) {
      api.createRecord('6e7307ee', component.options)
    } else {
      api.reload('6e7307ee', component.options)
    }
    module.hot.accept("./PurchasePerMonthCompareSettings.vue?vue&type=template&id=6e7307ee&scoped=true", function () {
      api.rerender('6e7307ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/PurchasePerMonthCompareSettings.vue"
export default component.exports